import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-answer-button',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './answer-button.component.html',
  styleUrl: './answer-button.component.scss'
})
export class AnswerButtonComponent {

  @Input() selected = false;
  @Input() answer = '';

  @Output() sendOptionEvent = new EventEmitter<string>();

  sendOptions(answer:string){
    this.sendOptionEvent.emit(answer);
  }

}
